export enum TaxpayerType {
  LARGE_TAXPAYER = 1,
  MEDIUM_TAXPAYER = 2,
  SMALL_TAXPAYER = 3,
  OTHER = 0,
}

export const taxpayerTypes: IDictionary<ISelect> = {
  [TaxpayerType.LARGE_TAXPAYER]: {
    value: TaxpayerType.LARGE_TAXPAYER,
    label: 'Grande contribuyente',
  },
  [TaxpayerType.MEDIUM_TAXPAYER]: {
    value: TaxpayerType.MEDIUM_TAXPAYER,
    label: 'Mediano contribuyente',
  },
  [TaxpayerType.SMALL_TAXPAYER]: {
    value: TaxpayerType.SMALL_TAXPAYER,
    label: 'Pequeño contribuyente',
  },
  [TaxpayerType.OTHER]: {
    value: TaxpayerType.OTHER,
    label: 'Otros',
  },
}
